import { fetchOperands } from '../../../api/Argentia/endpoints/operands/operands.api'
import {
  apiFetchPriceTypeCalculationTypeCompatibility,
  apiFetchPriceTypeCompatibility,
  fetchPrices,
  validatePriceExpression,
  validatePriceExpressionType
} from '../../../api/Argentia/endpoints/pricing/pricing.api'
import { EnumCommodity, EnumPriceCalculationType } from '../../../api/Argentia/enums'
import { EnumPriceType } from '../../../api/oData/enums/enumPriceType'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../../model/serviceResponse'

export const fetchValidatePriceExpression = async (
  expression: string
): Promise<ServiceResponse<any>> => {
  const request = { expression: expression, naturalLang: true }
  return await validatePriceExpression(request)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchValidateExpressionType = async (
  expression: string,
  priceCalculationType: EnumPriceCalculationType
): Promise<ServiceResponse<any>> => {
  const request = { expression: expression, priceCalculationType: priceCalculationType }
  return await validatePriceExpressionType(request)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchPriceTypeCalculationTypeCompatibility = async (): Promise<
  ServiceResponse<any>
> => {
  return await apiFetchPriceTypeCalculationTypeCompatibility()
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchPriceTypeCompatibility = async (
  priceType: EnumPriceType
): Promise<ServiceResponse<any>> => {
  return await apiFetchPriceTypeCompatibility(priceType)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchPricesList = async (
  commodity: EnumCommodity,
  priceType: EnumPriceType[]
): Promise<ServiceResponse<any>> => {
  return await fetchPrices(commodity, priceType)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchOperandsList = async (): Promise<ServiceResponse<any>> => {
  return await fetchOperands()
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
